module.exports = "images/doc-cotation-add-3.c6507fec80495368b7dd67f507c47195.png";